define('views/user/register/financial/failure',["backbone",
         "text!views/user/register/financial/failure.html",
         "views/_base/baseview",
          "models/shared/user/user",
              
], function (Backbone, Template, BaseView, User) {
    "use strict";

    return BaseView.extend({
        isRender: true,
        needsAuth: true,
        template: _.template(Template),
        events: {
            "click #cancelEdit": "cancelEdit",
            "click #editDetails": "editDetails"
        },
        tagName: "section",
        id:"financialRegVerifyFailure",
        initialize: function (options) {
            options = options || {};

            this.gender = options.gender;
            this.Message = options.Message;

            this.header = "Please Contact Member Services";
            this.explain = "Unfortunately, we weren't able to verify your information. Please contact Member Services to resolve the issue.";
            //if (this.Message != "failed") {
            //    var parsed = this.model.parse(this.model.attributes);
            //    this.model = new User(this.model.attributes);
            //}
            this.elementName = options.elementName;
            BaseView.prototype.initialize(this);
        },
        render: function () {
            //if (this.Message != "failed") {
             //   var data = this.model.toJSON();
           // }
            if (this.Message && this.Message == 'Zipcode not supported') {
                this.header = "Thank you for your interest in the PayForward<sup><small><%= sysText.SB.r %></small></sup> Prepaid Visa<sup><small><%= sysText.SB.r %></small></sup> Debit Card";
                this.explain = "<p>The PayForward prepaid card is not yet available in your area. We will be expanding to other regions soon.</p>";
            }
            this.$el.html(this.template());
            //if (this.Message)
              //  pfdialog.error({ context: this, Body: this.Message, Title: "Error" });
            return this;
        },
        //cancelEdit: function (e) {
        //    if (e && e.preventDefault) { e.preventDefault(); }
        //    if (e && e.stopPropagation) { e.stopPropagation(); }

        //    if (!isInApp()) {
        //        pf.navigate("");
        //        this.cleanup();
        //    }
        //},
        //editDetails: function (e) {

        //    if (e && e.preventDefault) { e.preventDefault(); }
        //    if (e && e.stopPropagation) { e.stopPropagation(); }
        //    var that = this;
        //    new require(["views/user/register/financial/memberapplication"], function (ApplicationView) {
        //        var applicationView = new ApplicationView({ model: new User(that.model), elementName:"#mainRegion" });                
        //    });
            
        //    //var financialRegView = new FinancialRegView({model: new User(that.model), elementName: "#mainRegion" });
        //    //pf.show(financialRegView);
        //    this.cleanup();
        //},
        close: function () {
        }
    });
});

